import axios from 'axios';
import FastSax from 'fast-sax';

export const tmxService = {
    listTmx,
	findTmx,
	downloadTmx,
	uploadTmx,
	updateTmx,
	parseTmx,
	search
};

function listTmx() {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/tmx/", {params: {}});
}

function findTmx(idCustomer, idLangPair) {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/tmx/"+idCustomer+"/"+idLangPair+"/", {params: {}});
}

function downloadTmx(idTmx) {
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/tmx/"+idTmx+"/content", {params: {}});
}
function validateTmx(idTmx){
	return axios.get(process.env.REACT_APP_serverURL+"/documents-0.0.1/tmx/"+idTmx+"/validation", {params: {}});
}

function uploadTmx(tmx, lpId, description){
//	console.log("docHref: "+docHref);
	var tmxData = new Object();
	tmxData.lpid = lpId;
	tmxData.description  = description;
	
	const headers = {
		headers: {
			'content-type': 'multipart/form-data'
		},
		params: {
		}
	}
	const formData = new FormData();
	formData.append('tmx', new File([tmx], tmx.name, { type: tmx.type }));
	formData.append('data', JSON.stringify(tmxData));
	return axios.post(process.env.REACT_APP_serverURL+"/documents-0.0.1/tmx/", formData, headers);
}

function updateTmx(tmxId, description, tmx){
//	console.log("docHref: "+docHref);
	var tmxData = new Object();
	tmxData.description  = description;
	
	const headers = {
		headers: {
			'content-type': 'multipart/form-data'
		},
		params: {
		}
	}
	const formData = new FormData();
	formData.append('data', JSON.stringify(tmxData));
	if(tmx){
		formData.append('tmx', new File([tmx], tmx.name, { type: tmx.type }));
	}
	return axios.put(process.env.REACT_APP_serverURL+"/documents-0.0.1/tmx/"+tmxId+"/", formData, headers);
}

function parseTmx(tmx){
	var parser = new FastSax();
	
	var currentSegment;
	var currentTU;
	var TUs = new Array();
	var inSegment=false;
	var newSegment=false
	var segIndex=0;
	
	function TU(codi, fecha){
		this.codi=codi;
		this.fecha=fecha;
		this.segments=new Array(2);
	};
	
	function Segment(){
		this.text="";
		this.tags=new Array();
	};
	
	function Tag(name, type, id, position, order){
		this.name = name;
		this.type = type;
		this.id = id;
		this.position = position;
		this.order = order;
	}
	
	parser.onElementStart = function(elementName, getAttributes) {
		const attributes = getAttributes();
		switch(elementName){
			case "tu":
				let codi= (typeof attributes["codi"] !== "undefined")?attributes["codi"]:"";
				let fecha=(typeof attributes["fecha"] !== "undefined")?attributes["fecha"]:"";
				currentTU = new TU(codi, fecha);
				segIndex=0;
			break;
			
			case "seg":
				inSegment=true;
				newSegment=true;
				currentSegment = new Segment();
			break;
			
			default:
				if(inSegment){
					currentSegment.tags.push(new Tag(elementName, "ALONE", attributes["id"], currentSegment.text.length, currentSegment.tags.length));
				}
		}
	}
	
	parser.onElementEnd = function(elementName) {
		switch(elementName){
			case "tu":
				TUs.push(currentTU);
			break;
			
			case "seg":
				inSegment=false;
				currentTU.segments[segIndex]=currentSegment;
				segIndex++;
			break;
		}
	}
	
	parser.onText = function(getText) {
		const text = getText();
		
		if(newSegment && inSegment){
			currentSegment.text=text;
			newSegment=false;
		}else if(inSegment){
			currentSegment.text+=text;
		}
	}
	
	parser.parse(tmx);
	//console.log("Parse complete.");
	
	return TUs;
}

function search(tmx, search, index){
	let i=tmx.length;
	let count=0;
	let trobat=false;
	//console.log("[search length] "+i);
	while(!trobat && i>0){
		--i;
//		console.log("search: "+tmx[i].segments[0].text);
		if(tmx[i].segments[0].text.indexOf(search)>-1){
			count++;
			if(count>index){
				trobat=true;
			}
		}
	}
	//console.log("[search done] "+trobat+" ["+i+"]");
	return(trobat?i:false);
}